import {
  EmptyState,
  GenericIconName,
  Icon,
  Text,
  tabletAndUp,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc, {css} from 'styled-components';

export const NotificationCenterEmptyState: React.FC<{
  title: string;
  subtitle: React.ReactNode;
  cta?: React.ReactNode;
}> = ({title, subtitle, cta}) => (
  <StyledEmptyState
    title={
      <StyledTitle size="px20" weight="mediumHeavy">
        {title}
      </StyledTitle>
    }
    subtitle={<StyledText size="px14">{subtitle}</StyledText>}
    asset={
      <EmptyStateIcon
        asset={GenericIconName.NotificationCenterEmptyState}
        size="XXL"
      />
    }
    cta={cta}
    data-testid="notificationCenter-emptyStream"
  />
);

const StyledEmptyState = sc(EmptyState)`
  bottom: 0;
  gap: 14px;
  margin: auto;
  position: relative;
  top: 0;

  ${tabletAndUp(css`
    margin: 80px 0 0 0;
    flex-direction: column;

    & div {
      text-align: center;
    }
  `)}
`;

const EmptyStateIcon = linariaStyled(Icon)`
  margin: auto;
  max-height: 140px;
  max-width: 200px;

  && {
    height: 100%;
    flex-basis: 100%;
    width: 100%;
  }
`;

const StyledTitle = sc(Text)`
  line-height: 24px;

  ${tabletAndUp(css`
    padding: 0 16px;
  `)}
`;

const StyledText = sc(Text)`
  line-height: 20px;

  ${tabletAndUp(css`
    padding: 0 16px;
  `)}
`;
